import React, { useEffect, useState } from 'react';
import { SubBox, RecordPlayProgress, RecordPlayTime } from '../../styles/contentsStyles';

import { timeFormat, textSilce } from '../../constants/index';

import ContentsType from './ContentsType';
import LazyImages from '../../pages/common/LazyImages';

const ContentsBox = ({
  className,
  data,
  width,
  goDetail,
  display,
  contetentWidth,
  contetentHeight,
  row,
  type,
  playBtn,
  showCompany,
  colorFix,
  animation,
  imgCenterText,
  imgOpacity,
}) => {
  let percent;
  let playTime;
  const [img, setImg] = useState('');

  useEffect(() => {
    // Content Type 별 이미지
    let _img = '';
    if (data.img instanceof Array) {
      data.img = data.img[0];
    }
    if (data?.episode?.img instanceof Array) {
      data.episode.img = data.episode.img[0];
    }

    if (data?.img?.url) _img = data?.img?.url ? data?.img?.url : '';
    else if (data?.episode?.img?.url) _img = data?.episode?.img?.url ? data?.episode?.img?.url : '';

    if (type === 'tide') _img = data?.files ? data?.files[0].url : '';
    if (type === 'contest') _img = data?.files ? data?.files[0].url : '';
    if (type === 'fishing') _img = data?.files ? data?.files[0].url : '';
    if (type === 'today-program')
      _img = data?.program?.img ? (data?.program?.img instanceof Array ? data?.program?.img[0]?.url : data?.program?.img?.url) : '';
    if (type === 'search-fishing') _img = data?.files ? data?.files[0].url : '';

    setImg(_img);
  }, [data]);

  if (type === 'vod-record') percent = (data?.playTime / data?.maxTime) * 100;
  if (type === 'vod-record') playTime = timeFormat(data?.playTime);

  return (
    <SubBox
      className={className}
      width={width}
      display={display}
      contetentWidth={contetentWidth}
      contetentHeight={contetentHeight}
      row={row}
      onClick={() => goDetail(data)}
      type={type}
      colorFix={colorFix}
      animation={animation}
      imgCenterText={imgCenterText}
      imgOpacity={imgOpacity}
    >
      <div className='contents_img_box' style={{ position: 'relative' }}>
        <LazyImages className='contents_img' src={img} alt={data?.img?.name} />
        {playBtn && <img alt='playBtn' className='playBtn' src={`/assets/Ftv/Icon/ic_playBtn.png`} />}
        {type === 'vod-record' && (
          <>
            <RecordPlayTime>{playTime}</RecordPlayTime>
            <RecordPlayProgress gage={percent}>
              <span className='progressGage' />
            </RecordPlayProgress>
          </>
        )}
        {(type === 'main-vod' || type === 'rec-vod') && (
          <div className='main-vod'>
            <h1>{data?.episodeNo && `${data?.episodeNo}화`}</h1>
            <span>{data?.title && textSilce(data?.title, 10)}</span>
          </div>
        )}
      </div>

      <article className='contents_Box'>
        <ContentsType data={data} type={type} showCompany={showCompany} />
      </article>
    </SubBox>
  );
};

export default ContentsBox;
